import { useEffect, useState } from "react";
import { toast } from "sonner";

export const MAX_FILES = 30;

export const validateFiles = (files) => {
  const isPdf = (f) => f.type === "application/pdf" || /\.pdf\s*$/i.test(f.name) || !f.type;
  if (files.some((f) => !isPdf(f))) return "Seleziona solo file PDF.";
  if (files.length > MAX_FILES) return `Puoi caricare al massimo ${MAX_FILES} file alla volta.`;
  if (files.some((f) => f.size > 50 * 1024 * 1024)) return "Ogni file deve essere al massimo di 50 MB.";
  return null;
};

export const useFileQueue = () => {
  const [queue, setQueue] = useState([]);

  const addFiles = (fileList) => {
    const incoming = Array.from(fileList || []);
    if (!incoming.length) return;
    const fresh = incoming.filter((f) => !queue.some((q) => q.name === f.name && q.size === f.size));
    const next = [...queue, ...fresh];
    const problem = validateFiles(next);
    if (problem) {
      toast.error(problem);
      return;
    }
    if (fresh.length < incoming.length) toast.info("Alcuni file erano già nella lista.");
    setQueue(next);
  };

  const removeAt = (i) => setQueue((q) => q.filter((_, j) => j !== i));
  const move = (i, dir) => setQueue((q) => {
    const j = i + dir;
    if (j < 0 || j >= q.length) return q;
    const next = [...q];
    [next[i], next[j]] = [next[j], next[i]];
    return next;
  });
  const clear = () => setQueue([]);
  return { queue, addFiles, removeAt, move, clear };
};

export const useWindowDrop = (onDrop, enabled = true) => {
  useEffect(() => {
    const prevent = (e) => e.preventDefault();
    const drop = (e) => {
      e.preventDefault();
      if (enabled && e.dataTransfer?.files?.length) onDrop(e.dataTransfer.files);
    };
    window.addEventListener("dragover", prevent);
    window.addEventListener("drop", drop);
    return () => {
      window.removeEventListener("dragover", prevent);
      window.removeEventListener("drop", drop);
    };
  });
};

export const saveBlob = (data, name) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const directDownload = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const postDownload = (url, fields) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  form.style.display = "none";
  Object.entries(fields).forEach(([k, v]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = k;
    input.value = v;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
  form.remove();
};

export const filesForm = (files) => {
  const form = new FormData();
  files.forEach((f) => form.append("files", f));
  return form;
};
